import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import EexploreMoreItem from './EexploreMoreItem'
import { mobileIs, loadScrollMagic, getOverallSettingsClasses } from "../../utils/siteUtils";
import "./style.scss";
let playIng = false
let activeIndex = 0
const ExploreMore = ({ page, lang, rendering, fields }) => {
  const { list } = fields
  const isAR = page?.fields?.rtl?.value;
  const mainEl = useRef();
  const pagingEl = useRef();
  const listEl = useRef();
  let timer = null;
  const isMobile = mobileIs();
	const [count, setCount] = useState(0);
	const [initIndex, setInitIndex] = useState(0);
	const [itemActiveIndex, setItemActiveIndex] = useState(0);
  let ScrollMagic, controller, scene, scene2;
  useEffect(() => {
    if(!isMobile && list.length > 1){
      ScrollMagic = loadScrollMagic();
      controller = new ScrollMagic.Controller();
      scene = new ScrollMagic.Scene({
        triggerElement: mainEl.current,
        triggerHook: 0,
        duration: 2111,
      })
      .setPin(pagingEl.current)
      .addTo(controller)
      scene2 = new ScrollMagic.Scene({
        triggerElement: mainEl.current,
        triggerHook: 0,
        duration: 2111,
      })
      .setPin(listEl.current)
      .addTo(controller);
    }
    if(!isMobile){
      window.addEventListener("mousewheel", onScroll );
    }
    return () => {
      if(!isMobile){
        window.removeEventListener("mousewheel", onScroll);
        activeIndex = 0
        playIng= false
        scene.destroy(true);
        scene = null;
        scene2.destroy(true);
        scene2 = null;
        controller&&controller.destroy(true);
        controller = null;
      }
    }
  }, []);
  const onScroll = event => {
    var ev = ev || window.event;
    let clientWidth = document.documentElement.clientWidth
    let clientHeight = document.documentElement.clientHeight
    let domOffsetTop = document.getElementById(rendering.uid).offsetTop;
    let newListWidth= clientWidth * list.length
    let top = mainEl?.current?.getBoundingClientRect().top;
    let height = mainEl?.current?.getBoundingClientRect().height;
    var down = true; 
    down = ev.wheelDelta ? ev.wheelDelta < 0 : ev.detail > 0;
    //初始动画
    if( Math.abs(top) < clientHeight*0.7 && top>0){
      setInitIndex(-1)
    }
    if( Math.abs(top) >= clientHeight && top>0){
      setInitIndex(0)
      if(!isMobile){
        listEl.current.style.zIndex = 2
      }
    }
    if(list.length == 1) return false
    // console.log('滑')
    // console.log(`playIng:${playIng}, top:${top}, clientHeight:${clientHeight}, down:${down}，clientWidth：${clientWidth},newListWidth:${newListWidth}, ${-clientHeight - 2111}` )
    if(!playIng && ((top > -clientHeight - 2111 && down) || (!down && top> -2111)) ){
      //处理位移
      let translateX = 0;
      if(clientWidth>newListWidth) return 
      var osmall = listEl.current
      translateX = Number(osmall.style.transform.replace('translateX(','').replace('px)',''));
      if( (down && activeIndex != list.length-1) || (!down && activeIndex != 0)){
        playIng = true
        setTimeout(v=>{
          playIng = false
        },1250)
      }

      if (down) {
        // console.log(`向下： newListWidth:${newListWidth} translateX:${translateX} newListWidth- clientWidth:${newListWidth- clientWidth} `)
        if(((Math.abs(translateX) < (parseInt(newListWidth- clientWidth)  )) || translateX == 0)  && top <= 10){
          // console.log('向下成功')
          if(isAR){
            osmall.style.transform = `translateX(${translateX+clientWidth}px)`;
            if(Math.abs(translateX + clientWidth)>newListWidth-clientWidth){
              setCount(Math.abs(clientWidth - newListWidth));
              setItemActiveIndex(list.length - 1)
              activeIndex = list.length - 1
            }else{
              setCount(translateX-clientWidth * -1);
              setItemActiveIndex(activeIndex+1)
              activeIndex ++
            }
          }else{
            osmall.style.transform = `translateX(${translateX-clientWidth}px)`;
            if(Math.abs(translateX - clientWidth)>newListWidth-clientWidth){
              setCount(clientWidth - newListWidth);
              setItemActiveIndex(list.length - 1)
              activeIndex = list.length - 1
            }else{
              setCount(translateX-clientWidth);
              setItemActiveIndex(activeIndex+1)
              activeIndex ++
            }
          }
          if(!isMobile){
            listEl.current.style.zIndex = 1
            setTimeout(v=>{
              listEl.current.style.zIndex = 2
            },1250)
          }
        }
      } else {
        // console.log(`向上： newListWidth:${newListWidth} translateX:${translateX} newListWidth- clientWidth:${newListWidth- clientWidth} `)
        if((!isAR && translateX<0 ) || (isAR && translateX>0 )){
          // console.log('向上成功')
          if(isAR){
            osmall.style.transform = `translateX(${parseInt(translateX)-parseInt(clientWidth)}px)`
            if(parseInt(translateX)-parseInt(clientWidth)<0){
              setCount(0);
              setItemActiveIndex(0)
              activeIndex = 0
            }else{
              setCount(parseInt(translateX)-parseInt(clientWidth));
              setItemActiveIndex(activeIndex-1)
              activeIndex --
            }

          }else{
            osmall.style.transform = `translateX(${parseInt(translateX)+parseInt(clientWidth)}px)`
            if(parseInt(translateX)+parseInt(clientWidth)>0){
              setCount(0);
              setItemActiveIndex(0)
              activeIndex = 0
            }else{
              setCount(parseInt(translateX)+parseInt(clientWidth));
              setItemActiveIndex(activeIndex-1)
              activeIndex --
            }
          }
          if(!isMobile){
            listEl.current.style.zIndex = 1
            setTimeout(v=>{
              listEl.current.style.zIndex = 2
            },1250)
          }
        }
      }
    }
    //判断滚动条显示隐藏
    if (down) {
      if(activeIndex != list.length-1 && top <=-100){
        document.body.style.overflowY = "hidden";
        // scrollTopWin = document.documentElement.scrollTop;
        mainEl.current.style.paddingRight = "6px";
        pagingEl.current.style.paddingRight = "6px";
      }
      if((activeIndex == list.length-1 && top <=0  && Math.abs(top)< 2111  )){
        document.documentElement.scrollTop = domOffsetTop + 2111
        setTimeout(v=>{
          if((activeIndex == list.length-1 && top <=0  )){
            document.body.style.overflowY = "auto";
            mainEl.current.style.paddingRight = "0";
            pagingEl.current.style.paddingRight = "0";
          }
        },1300)
      }
    }else{
      if((activeIndex == 0 && top> -2111 && top<=0)){
        document.documentElement.scrollTop = domOffsetTop 
        setTimeout(v=>{
          if((activeIndex == 0 && top> -2111 && top<=0)){
            document.body.style.overflowY = "auto";
            mainEl.current.style.paddingRight = "0";
            pagingEl.current.style.paddingRight = "0";
          }
        },1300)
      }
      if((activeIndex != 0 &&top> -2111 && top<=-100)){
        document.body.style.overflowY = "hidden";
        mainEl.current.style.paddingRight = "6px";
        pagingEl.current.style.paddingRight = "6px";
      }
    }
    //页面位于底部刷新时，修改初始index
    if( Math.abs(top) > height && top<0){ 
      setItemActiveIndex(list.length-1)
      if(isAR){
        setCount(Math.abs(clientWidth - newListWidth));
      }else{
        setCount(clientWidth - newListWidth);
      }
      activeIndex = list.length-1
    }

          
  }
  const rootClasses = classNames("exploreMore", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={mainEl} id={rendering.uid}>
      <div className="exploreMore-main">
        <div className="exploreMore-main-paging" ref={pagingEl}>
          {/* <div>
            <div>
              <div className="before">0{itemActiveIndex+1}</div>
              <div className="line"></div>
              <div className="after">0{list.length}</div>
            </div>
          </div> */} 
        </div>
        <div className="exploreMore-main-list" ref={listEl}  style={{transform:[`translateX(${count}px)`]}}>
          {
            list.map( (item, index) => {
              return (
              <div className={classNames("exploreMore-main-list-item", initIndex === index ? 'init' : '',itemActiveIndex == index ? 'active' : '')} key={index}>
                <EexploreMoreItem data={item} index={index} dataSource={rendering.dataSource} />
              </div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
};
export default ExploreMore;
